import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import { useShallow } from "zustand/react/shallow";

import { useUiStore } from "@/stores/uiStore";

export function PageMeta() {
  const title = useUiStore(useShallow((state) => state.pageTitle));
  const { t } = useTranslation("pageTitle");

  return (
    <Helmet>
      <title>
        {title ? `${t("pageMeta.title")} - ${t(title)}` : t("pageMeta.title")}
      </title>
      <meta name={"description"} content={t("pageMeta.description")} />
      <meta name={"keywords"} content={t("pageMeta.keywords")} />
      <meta name={"author"} content={t("pageMeta.author")} />
    </Helmet>
  );
}
